import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import overlayFactory from 'react-bootstrap-table2-overlay';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { Edit } from '../Icons/Icons';
import { Tooltip } from '../Utils/Tooltips';
import { interopSystemEnum } from '../../variables/Enums';

// MedicalRecords.API serializa InteropSystem como el valor numérico del enum (Newtonsoft sin
// StringEnumConverter) - acá lo mapeamos de vuelta al nombre usando el mismo enum del front.
const interopSystemLabel = value =>
    Object.keys(interopSystemEnum).find(key => interopSystemEnum[key] === value) ?? value;

export default function FrequentConceptsTable({ data, query, totalSize, onTableChange, isLoading, onEdit }) {
    const { t } = useTranslation();

    const columns = [
        { dataField: 'description', text: t('settings.settings.frequentConcepts.columns.term') },
        { dataField: 'interopSystem', text: t('settings.settings.frequentConcepts.columns.interopSystem'), formatter: interopSystemLabel, headerStyle: { width: '150px' } },
        { dataField: 'usageCount', text: t('settings.settings.frequentConcepts.columns.usageCount'), headerStyle: { width: '100px' } },
        {
            dataField: 'actions',
            text: t('commons.actions'),
            isDummyField: true,
            headerStyle: { width: '100px' },
            formatter: (_cell, row, rowIndex) => (
                <div key={rowIndex}>
                    <button type="button" className="btn-table-actions" onClick={() => onEdit(row)}>
                        <Tooltip tooltip={t('settings.settings.frequentConcepts.edit')} id={"tooltip-frequent-concept-" + row.id}>
                            <Edit />
                        </Tooltip>
                    </button>
                </div>
            )
        }
    ];

    return (
        <BootstrapTable
            remote
            bordered={false}
            hover
            keyField="id"
            classes="table-spaced table-spaced-small"
            wrapperClasses="table-responsive"
            data={data}
            columns={columns}
            noDataIndication={() => isLoading ? <span /> : <span>{t('commons.noData')}</span>}
            pagination={paginationFactory({
                page: query.pageIndex + 1,
                sizePerPage: query.pageSize,
                totalSize,
                hideSizePerPage: true,
            })}
            onTableChange={onTableChange}
            loading={isLoading}
            overlay={overlayFactory({ spinner: true })}
        />
    );
}

FrequentConceptsTable.propTypes = {
    data: PropTypes.array.isRequired,
    query: PropTypes.object.isRequired,
    totalSize: PropTypes.number.isRequired,
    onTableChange: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    onEdit: PropTypes.func.isRequired,
};
